import Head from "next/head";
import * as prismic from "@prismicio/client";
import { SliceZone } from "@prismicio/react";

import { createClient } from "@/prismicio";
import { components } from "@/slices";
import { Layout } from "@/components/Layout";
import CtaBar from "@/components/CtaBar/CtaBar";
import PageHeading from "@/components/PageHeading/PageHeading";
import { Box } from "@chakra-ui/react";
// import Header1Component from "@components/Header1Component/Header1Component";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import Meta from "../shared/Meta";

const Page = ({ page, navigation, settings }) => {
  // const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <Layout
      navigation={navigation}
      settings={settings}
      headerStyle={page.data.header_style}
      logoStyle={page.data.logo_style}
    >
      {prismic.asText(page.data.title) && (
        <PageHeading title={page.data.title} />
      )}

      <Meta
        meta_title={page.data.seo_page_title || ""}
        meta_description={page.data.seo_meta_description || ""}
        exclude_from_sitemap={false}
        no_follow={false}
        no_index={false}
      />

      <SliceZone slices={page.data.slices} components={components} />
    </Layout>
  );
};

export default Page;

export async function getStaticProps({ params, locale, previewData }) {
  const client = createClient({ previewData });

  const page = await client.getByUID("page", params.uid, { lang: locale });
  const navigation = await client.getSingle("navigation", { lang: locale });
  const settings = await client.getSingle("settings", { lang: locale });
  // console.log("settings here are", settings.data.email);

  return {
    props: {
      page,
      navigation,
      settings,
    },
    revalidate: 10,
  };
}

export async function getStaticPaths() {
  const client = createClient();

  const pages = await client.getAllByType("page", { lang: "*" });

  return {
    paths: pages.map((page) => {
      return {
        params: { uid: page.uid },
        locale: page.lang,
      };
    }),
    fallback: false,
  };
}
